declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export const pushDataLayerEvent = (
  event: string,
  properties: Record<string, unknown> = {},
) => {
  if (!window.dataLayer) return;
  window.dataLayer.push({
    event,
    ...properties,
  });
};
